import { RefObject, useContext, useState } from "react"
import { LangContext } from "../../../App";

type TabsViewPropsType = {
    titles : string[], 
    data : JSX.Element[], 
}

const TabsView = ({ titles, data } : TabsViewPropsType) => {
    const { lang } = useContext(LangContext);
    const [tabIndex, setTabIndex] = useState<number>(0);

  return (
    <div className={`tabs-view ${lang ? "rtl" : ""}`} id="tabsView">
        <div className="tabs-headers">
            <div className="tabs-headers-box">
                {
                titles.map((item,index) => (
                    <button 
                        key={index} 
                        className={`tab-button ${index === tabIndex ? "active" : ""}`}
                        onClick={() => {
                            setTabIndex(index);
                            document.getElementById("tabsView")?.scrollIntoView();
                        }}
                        title={`Show ${item} tab`}
                        aria-label={`Show ${item} tab`}
                        aria-pressed={index !== tabIndex}
                    >
                        {item}
                    </button>
                ))
                }
            </div>
        </div>
        <div className="tab-container">
            {data[tabIndex]}
        </div>
    </div>
  )
}

export default TabsView